// import { useSelector } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./index.css";
import image from "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from "./img/back.png";
import axios from "axios";
// import { clientCredentials } from "axios-oauth-client";
import { GET_POWERTOKEN } from "../../Pages/AppConstant";

function Powerbi() {
  const [tokendata, SetTokendata] = useState("");
  useEffect(() => {
    gettoken();
    getsession();
  }, []);


  const redirectToLogin = () => {
    window.location.href = "/login";
  };
  const redirectTodashboard = () => {
    window.location.href = "/landingPage";
  };


  const getsession=()=>{
    if(localStorage.getItem('sessions')!=="isactive"){
        window.location.href = "/"
    }       
}
  const gettoken = () => {
    axios({
      method: "get",
      url: GET_POWERTOKEN,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => {
        SetTokendata(response.data["access_token"]);
        console.log(response.data["access_token"]);
        //setCommissiondata(response.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <section className="App bg_set_bi">
      <div className="switch ">
        <img
          className="switch-back"
          onClick={redirectTodashboard}
          src={imagebk}
        />
        <img className="switch-img" src={image} />
        <img
          className="logout-img"
          title="Logout"
          onClick={redirectToLogin}
          src={logoutimg}
        />
      </div>
      {/* <div className="Padding-hd">
      <h3>Switch Business Intelligence</h3>
      </div> */}
      {tokendata !== "" ? (
        <section id="bi-report">
          <PowerBIEmbed
            embedConfig={{
              type: "report", // Since we are reporting a BI report, set the type to report
              id: "5c69e155-5665-4ff4-bfbb-d43f344e53d2", 
              //id: "9f9f3508-7f0e-47af-8ad3-2421b80d458b",// Add the report Id here
              // embedUrl:
              //   "https://app.powerbi.com/reportEmbed?reportId=5c69e155-5665-4ff4-bfbb-d43f344e53d2&groupId=f98a8f6a-9082-4c51-b9b5-f414b5148362&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVLLVNPVVRILXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19", 
                 embedUrl:
                "https://app.powerbi.com/reportEmbed?reportId=df75710f-7c30-4516-b958-ea3b464389fb&groupId=f98a8f6a-9082-4c51-b9b5-f414b5148362&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVLLVNPVVRILXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19", // Add the embed url here
              accessToken: tokendata, // Add the access token here
              tokenType: models.TokenType.Embed, // Since we are using an Azure Active Directory access token, set the token type to Aad
              settings: {
                navContentPaneEnabled: false,
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                },
                background: models.BackgroundType.Transparent,
              },
            }}
            eventHandlers={
              new Map([
                [
                  "loaded",
                  function () {
                    console.log("Report loaded");
                  },
                ],
                [
                  "rendered",
                  function () {
                    console.log("Report rendered");
                  },
                ],
                [
                  "error",
                  function (event) {
                    console.log(event.detail);
                  },
                ],
                ["visualClicked", () => console.log("visual clicked")],
                ["pageChanged", (event) => console.log(event)],
              ])
            }
            cssClassName={"bi-embedded"}
            getEmbeddedComponent={(embeddedReport) => {
              window.report = embeddedReport; // save report in window object
            }}
          />
        </section>
      ) : (
        ""
      )}
    </section>
  );
}

export default Powerbi;
